import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ConsolidatedRequestApplicationShared",
  props: {
    requestedDocuments: {
      type: Array,
      default: () => []
    },
    isMultiBorrowerRequest: {
      type: Boolean,
      default: false
    },
    expandOnInit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expanded: false
    };
  },
  computed: {
    hasDocumentsRequest() {
      var _this$documentRequest;
      return ((_this$documentRequest = this.documentRequestIds) == null ? void 0 : _this$documentRequest.length) > 0;
    },
    documentsRequested() {
      var _this$documentRequest2;
      return ((_this$documentRequest2 = this.documentRequestIds) == null ? void 0 : _this$documentRequest2.length) || 0;
    },
    filteredRequestedDocuments() {
      var _context;
      return _filterInstanceProperty(_context = this.requestedDocuments).call(_context, ({
        quantity
      }) => quantity);
    }
  },
  mounted() {
    this.expanded = this.expandOnInit;
  },
  methods: {
    toggleExpand() {
      this.expanded = !this.expanded;
    }
  }
});